const _excluded = ["inputService", "itemRender", "customSearchFilter", "keyLookup", "options", "label", "required", "allowClear", "hideLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from 'react';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Label } from '../../Label';
import { Stack } from '../../Stack';
import { TagPicker } from '../../TagPicker';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { SharedClearButton } from '../SharedClearButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TagPickerControl(_ref) {
  let {
      inputService,
      itemRender,
      customSearchFilter,
      keyLookup,
      options,
      label,
      required,
      allowClear,
      hideLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const {
    value,
    errorMessage,
    send,
    touched
  } = useInput(inputService);
  const tagPickerRef = useRef(null);
  const getSelectedItems = () => {
    if (!value) return [];
    const items = Array.isArray(value) ? value : [value];
    return items.map(item => ({
      key: keyLookup(item),
      name: itemRender(item)
    }));
  };
  const onResolveSuggestions = (filter, currentSelected) => {
    var _currentSelected$map;
    if (!filter) return [];
    const filteredOptions = customSearchFilter ? customSearchFilter(filter, options) : options.filter(item => keyLookup(item).toLowerCase().includes(filter.toLowerCase()));
    const selectedKeys = (_currentSelected$map = currentSelected === null || currentSelected === void 0 ? void 0 : currentSelected.map(s => String(s.key))) !== null && _currentSelected$map !== void 0 ? _currentSelected$map : [];
    return filteredOptions.filter(item => !selectedKeys.includes(keyLookup(item))).map(item => ({
      key: keyLookup(item),
      name: itemRender(item)
    }));
  };
  const onChange = items => {
    var _items$map;
    const selectedKeys = (_items$map = items === null || items === void 0 ? void 0 : items.map(i => String(i.key))) !== null && _items$map !== void 0 ? _items$map : [];
    const currentItems = Array.isArray(value) ? value : value ? [value] : [];
    const pool = [...options, ...currentItems];
    const picked = pool.filter((item, index, self) => {
      const key = keyLookup(item);
      return selectedKeys.includes(key) && self.findIndex(i => keyLookup(i) === key) === index;
    });
    const newValue = props.itemLimit === 1 ? picked[0] : picked;
    send([{
      type: 'FOCUS'
    }, {
      type: 'CHANGE',
      value: newValue
    }, {
      type: 'COMMIT'
    }, {
      type: 'BLUR'
    }]);
  };
  useEffect(() => {
    var _tagPickerRef$current, _tagPickerRef$current2;
    // This effect hook will update the options dropdown asynchronously.
    // It's based on a suggestion from Fabric UI developer found here:
    // https://github.com/microsoft/fluentui/issues/9376#issuecomment-501481392
    const inputVal = (_tagPickerRef$current = tagPickerRef.current) === null || _tagPickerRef$current === void 0 || (_tagPickerRef$current = _tagPickerRef$current.input) === null || _tagPickerRef$current === void 0 || (_tagPickerRef$current = _tagPickerRef$current.current) === null || _tagPickerRef$current === void 0 ? void 0 : _tagPickerRef$current.value;
    (_tagPickerRef$current2 = tagPickerRef.current) === null || _tagPickerRef$current2 === void 0 || _tagPickerRef$current2.updateValue(inputVal !== null && inputVal !== void 0 ? inputVal : '');
  }, [options]);
  return /*#__PURE__*/_jsxs(Stack, {
    children: [!hideLabel && /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: [/*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          children: [label !== null && label !== void 0 ? label : name, " ", required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      }), allowClear && /*#__PURE__*/_jsx(Stack.Item, {
        align: "end",
        children: /*#__PURE__*/_jsx(SharedClearButton, {
          simple: allowClear === 'simple',
          send: send
        })
      })]
    }), /*#__PURE__*/_jsx(TagPicker, _objectSpread(_objectSpread({}, props), {}, {
      componentRef: tagPickerRef,
      onResolveSuggestions: onResolveSuggestions,
      onChange: onChange,
      onBlur: () => send({
        type: 'BLUR'
      }),
      onFocus: () => send({
        type: 'FOCUS'
      })
      // `selectedItems` can't be found in the official docs for some reason.
      // The usage here was derived from this StackExchange answer:
      // https://sharepoint.stackexchange.com/questions/241212/setting-default-value-office-ui-fabric-react-people-picker
      ,
      selectedItems: getSelectedItems()
    })), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error-".concat(index)))]
  });
}